// extracted by mini-css-extract-plugin
module.exports = {"title":"title-2viSti1g","title_mt":"title_mt-2KdSjPRk title-2viSti1g"};